export const AUTH_APP_ID_KEY = 'auth_app_id';
export const NON_RENEWING_SUBSCRIPTION_KEY = 'Non renewing';
export const DEFAULT_LOCALE = 'en';
export enum RM_TAGS {
  VideoPage = 'VideoPage',
  PathwayPage = 'PathwayPage',
  ExpertPage = 'ExpertPage',
  TestPage = 'TestPage',
  TermPage = 'TermPage',
  CategoryPage = 'CategoryPage',
  CourseSharePage = 'CourseSharePage',
  PathwaySharePage = 'PathwaySharePage',
  CoursePage = 'CoursePage',
  CourseProgressPage = 'CourseProgressPage',
  TeamPage = 'TeamPage',
  InviteToTeamPage = 'InviteToTeamPage',
  SinglePlanPage = 'SinglePlanPage',
  JoinTeamPage = 'JoinTeamPage',
  CustomPage = 'CustomPage',
}
export const DEFAULT_DISCOVER_URL = '/discover';
export const HEADER_IMG_SRC_SET = [
  { width: 500, quality: 80 },
  { width: 800, quality: 80 },
  { width: 1100, quality: 80 },
  { width: 1200, quality: 80 },
  { width: 1920, quality: 80 },
];
export const LAST_VIEWED_PATHWAY_SLUG_COOKIE_NAME = 'last_viewed_pathway_slug';
export const PRIORITY_PATHWAY_SLUG_COOKIE_NAME = 'priority_pathway_slug';

export enum USER_PROGRESS_ENTITY {
  Video = 'video',
  Pathway = 'pathway',
}

export enum USER_PROGRESS_EVENT {
  VideoWatched = 'videoWatched',
  TestPassed = 'testPassed',
}

export const ELOD_REFERENT = 'euromoney';
